__turbopack_context__.v({
  "banner": "DAd8Fa_banner",
  "body": "DAd8Fa_body",
  "closeButton": "DAd8Fa_closeButton",
  "ctaLink": "DAd8Fa_ctaLink",
  "inner": "DAd8Fa_inner",
  "main": "DAd8Fa_main",
  "separator": "DAd8Fa_separator",
  "text": "DAd8Fa_text",
  "title": "DAd8Fa_title",
});
